





















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'active-filter'
})

export default class extends Vue {
  @Prop() readonly dataSource: string;
  @Prop() readonly activeFilters: Array<object>;

  private filterOpen: boolean = false;

  private toggleFilter(): void {
    this.filterOpen = !this.filterOpen;
  }

  private get activeFilterCount(): number {
    return (this.$store.getters[`${this.dataSource}/activeFilters`].map(
      f => f.options.filter(o => o.active).length
    ).reduce((a, b) => a + b, 0) || 0);
  }

  private removeActiveFilter(filter, option): void {
    this.$store.dispatch(`${this.dataSource}/toggleFilter`, {filter: filter, option: option});
    if (this.activeFilterCount === 0) {
      this.filterOpen = false;
    }
  }
}
